import { call, put, takeLatest, select } from 'redux-saga/effects'

import { RedeemAPI, RewardsAPI } from 'primsell-shared-layer/api'
import APP_CONFIG from 'primsell-shared-layer/core/config'
import { campaignPublicSelector, rewardPublicSelector, walletAddressSelector } from 'primsell-shared-layer/features'
import { ContractReadService } from 'primsell-shared-layer/core/services/contractRead'

import { RedeemActions } from 'features'
import { RedeemStepsE } from 'types'

const redeemAddress = APP_CONFIG.contractRedeem.get(137)

export function* checkIsEventApprovedForAll(): Generator<any, boolean, any> {
  const address = yield select(walletAddressSelector)
  const campaignPublicDetails = yield select(campaignPublicSelector)

  const isApprovedForAllResult = (yield call(
    [new ContractReadService(), 'isApprovedForAll'],
    ...[campaignPublicDetails.contractAddress, address, redeemAddress]
  )) as boolean

  return isApprovedForAllResult
}

export function* checkIsRewardApprovedForAll(): Generator<any, boolean, any> {
  const address = yield select(walletAddressSelector)

  const rewardPublicDetails = yield select(rewardPublicSelector)

  const isApprovedForAllResult = (yield call(
    [new ContractReadService(), 'isApprovedForAll'],
    ...[rewardPublicDetails.contract.address, address, redeemAddress]
  )) as boolean

  return isApprovedForAllResult
}

export function* redeemEventSaga({ payload }: ReturnType<typeof RedeemActions.redeemEventRequest>): Generator {
  try {
    yield RedeemAPI.redeemEvent(payload)
    yield put(RedeemActions.redeemEventSuccess())
  } catch (error) {
    yield put(RedeemActions.redeemEventFailure((error as Error)?.message))
  }
}

export function* redeemRewardSaga({ payload }: ReturnType<typeof RedeemActions.redeemRewardRequest>): Generator {
  try {
    yield RedeemAPI.redeemRewardEvent(payload)
    yield put(RedeemActions.redeemRewardSuccess())
  } catch (error) {
    yield put(RedeemActions.redeemRewardFailure((error as Error)?.message))
  }
}

export function* checkEventAllowanceSaga(): Generator {
  try {
    const isApprovedForAll = (yield call(checkIsEventApprovedForAll)) as boolean

    yield put(RedeemActions.checkEventAllowanceSuccess({ isApprovedForAll }))

    if (isApprovedForAll) {
      yield put(RedeemActions.setCurrentStep(RedeemStepsE.SUBMIT_REDEEM))
    } else {
      yield put(RedeemActions.setCurrentStep(RedeemStepsE.SUBMIT_ALLOWANCE))
    }
  } catch (error) {
    yield put(RedeemActions.checkEvetnAllowanceFailure({ error: (error as Error)?.message }))
  }
}

export function* checkRewardAllowanceSaga(): Generator {
  try {
    const isApprovedForAll = (yield call(checkIsRewardApprovedForAll)) as boolean

    yield put(RedeemActions.checkRewardAllowanceSuccess({ isApprovedForAll }))

    if (isApprovedForAll) {
      yield put(RedeemActions.setCurrentStep(RedeemStepsE.SUBMIT_REDEEM))
    } else {
      yield put(RedeemActions.setCurrentStep(RedeemStepsE.SUBMIT_ALLOWANCE))
    }
  } catch (error) {
    yield put(RedeemActions.checkRewardAllowanceFailure({ error: (error as Error)?.message }))
  }
}

function* redeemSaga(): Generator {
  yield takeLatest(RedeemActions.redeemEventRequest, redeemEventSaga)
  yield takeLatest(RedeemActions.redeemRewardRequest, redeemRewardSaga)
  yield takeLatest(RedeemActions.checkEventAllowanceRequest, checkEventAllowanceSaga)
  yield takeLatest(RedeemActions.checkRewardAllowanceRequest, checkRewardAllowanceSaga)
}

export { redeemSaga }
